import JWTAuthenticator from 'ember-simple-auth-token/authenticators/jwt';

export default class SessionAuthenticator extends JWTAuthenticator {
  authenticate(session) {
    return Promise.resolve(this.handleAuthResponse(session));
  }
}
